import React from 'react';
import { Form } from 'antd';
import styled from 'styled-components';
const FormItemNoMarginStyled = styled(Form.Item)`
  margin: 10px;
`;
export default FormItemNoMarginStyled;
